/**
 * External dependencies
 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';

/**
 * Internal dependencies
 */
import { isSectionLoading, getSectionName, getCurrentPath } from 'state/ui/selectors';

/**
 * Style dependencies
 */
import './styles.scss';

class LoggedOutLayout extends Component {
	static propTypes = {
		primary: PropTypes.element,
		secondary: PropTypes.element,
	};
	render() {
		const sectionClass = classnames(
			'layout',
			{ 'has-no-sidebar': !this.props.hasSidebar },
			{ 'has-no-sidebar': !this.props.hasSidebar },
			`is-section-${this.props.sectionName}`,
		);
		return (
			<div className={sectionClass}>
				<div id='content' className='layout__content'>
					<div id='primary' className='layout__primary'>
						{this.props.primary}
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		isLoading: isSectionLoading(state),
		sectionName: getSectionName(state),
		path: getCurrentPath(state),
	};
};

export default connect(
	mapStateToProps,
	{},
)(LoggedOutLayout);
